import { navigationDrawerStyles } from "@insite/content-library/Components/NavigationDrawer";
import getColor from "@insite/mobius/utilities/getColor";
import { COLORS } from "@tSurya/theme/design";
import { css } from "styled-components";

navigationDrawerStyles.menuTriggerButton = {
    css: css`
        background: none;
        padding: 0px;
        border: none;
        :hover {
            background: none;
        }
        span {
            color: ${getColor("text.main")} !important;
        }
    `,
};
